// extracted by mini-css-extract-plugin
export default {"button":"b0siX1viJV9yIjU--zhGjQ==","shadow":"sIXFND3OpHwu1IcOZPD3sA=="};